import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"

const Value = ({ blok }) => (
  <SbEditable content={blok}>
    <div className="table__value">
      <p className="table__value-heading">{blok.heading}</p>
      <p className="table__value-data">{blok.value}</p>
    </div>
  </SbEditable>
)

Value.propTypes = {
  blok: PropTypes.shape({
    heading: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
}

export default Value
